import React from 'react'
import { Navigate } from 'react-router-dom'
import { isUserAuthenticated } from '../utils/TokenManager'
import { useSelector } from 'react-redux'
import AutoLogin from '../pages/Auth/AutoLogin'
import { PENDING } from '../constants/ApiEndPoints'
import { RootState } from '../redux/Store'
import LoaderPage from '../pages/Auth/LoaderPage'

const RequireAuth = ({ children }: any) => {
  // Check if the user is authenticated using TokenManager
  const isAuthenticated = isUserAuthenticated();
  const userStatus = useSelector((state: RootState) => state.user.currentUser)

  if (!isAuthenticated) {
    return <AutoLogin />;
  }

  if (userStatus.status?.toLowerCase() === PENDING) {
    return <LoaderPage />
  }

  return <>{children}</>;
}

export default RequireAuth
